class jfUpdateStatusController {

    constructor($timeout, $filter, $scope, HomepageDao, XRayUIState, JFrogEventBus, DatabaseSyncDao, $rootScope,
                JFrogModal, XRayUIPermissions, $interval) {
        this.homepageDao = HomepageDao;
        this.DatabaseSyncDao = DatabaseSyncDao;
        this.$interval = $interval;
        let EVENTS = JFrogEventBus.getEventsDefinition();
        this.XRayUIState = XRayUIState;
        this.JFrogEventBus = JFrogEventBus;
        this.XRayUIPermissions = XRayUIPermissions;
        this.getUpdateData();
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$filter = $filter;
        this.barWidth = 1;
        this.modal = JFrogModal;
        this.showBar = false;
        console.log("ctor")
        this.continueous_sync = {
            available: true,
            counter_action: ''
        };
        this.currentUpdate = 'online';
        this.$rootScope = $rootScope;

        if (this.XRayUIState.getState('sessionData')) {
            this.isAdmin = this.XRayUIPermissions.isAdmin();
        }
        let removeListener = JFrogEventBus.register(EVENTS.UPDATE_STATUS_CHANGE,
            (data) => this.setData(data, 'ws'));
        $scope.$on('$destroy', () => {
            removeListener();
            this.$interval.cancel(this.statusInterval);
        })
        if (this.XRayUIState.getState('sessionData')) {
            this.isAdmin = this.XRayUIPermissions.isAdmin();
        }

    }

    getUpdateData() {
        this.getStatus();
        this.statusInterval = this.$interval(() => {
            this.getStatus('interval');
        }, 10000);
    }

    getStatus(type = "normal") {
        this.DatabaseSyncDao.getStatus({$no_spinner: true, $suppress_toaster: true}).$promise.then((data) => {
            this.setData(data,type);
            if(type !=='interval'){
                this.currentUpdate = data.updates_mode;
                this.updateType = data.updates_mode;
            }
        });
    }

    setData(data, type = 'normal') {
        if (data) {
            data.updateOrigin= type
            this.JFrogEventBus.dispatch(this.JFrogEventBus.getEventsDefinition().UPDATE_STATUS_FETCHED, data);
            if (data.state === 'onboarding_vulnerabilities') {
                this.XRayUIState.setState('offline_sync_require', true);
            }

            this.updateData = {
                updated: data.last_updated,
                state: data.state,
                errorMsg: data.last_updates_error,
                updates_mode: data.updates_mode,
                update_type: data.update_state

            };

            if (data.current_index && data.total) {
                this.updateData.current_index = data.current_index;
                this.updateData.total = data.total;

            }
            this.setProgress(data);

            if (type == 'normal') {

            }
        }

    }

    setProgress(data) {
        let currentIndexKey;
        let currentTotalKey;

        if (data.updates_mode === 'offline') {
            currentIndexKey = 'offline_current_index';
            currentTotalKey = 'offline_total';
        } else {
            currentIndexKey = 'current_index';
            currentTotalKey = 'total';

        }

        if (data[currentTotalKey] && data[currentIndexKey]) {
            this.currentTotal = data[currentTotalKey];
            this.currentIndex = data[currentIndexKey];

            this.showBar = true;
            let current = parseInt(data[currentIndexKey]);
            let total = parseInt(data[currentTotalKey]);
            if (current > total) {

                total = current + 1;
                this.currentIndex = this.currentTotal;
                this.currentIndex--;

            }

            this.barWidth = Math.floor((current / total) * 100);
            if (this.barWidth < 1) {
                this.barWidth = 1;
            }
            if (data[currentTotalKey] == data[currentIndexKey]) {
                this.barWidth = 100;
                this.showBar = false;
            }

            this.totalTimeleft = Math.floor(((total - current) * 15) / 60);
            this.totalTimeleft = this.secondsToString(Math.floor(((total - current) * 15)));

        } else {
            this.showBar = false;
        }

    }

    getUpdateText() {


        this.continueous_sync.available = true;
        if (this.updateData.state === 'onboarding' || this.updateData.state === 'onboarding_vulnerabilities') {
            this.continueous_sync.counter_action = 'Start Sync (Online)';
            if (this.updateType == 'offline') {
                this.continueous_sync.counter_action = 'Upload local update';
            }

            return `<p>Data sync from global database server <span>has not yet started</span></p>`;
        } else if (this.updateData.state === 'running') {
            this.showBar = true;
            this.continueous_sync.counter_action = 'Pause Sync';
            if (this.updateType == 'offline' || this.currentUpdate == 'offline') {

                if (this.currentUpdate == 'online') {
                    return '<p>Syncing data from global components database</p>';
                }
                return '<p>Syncing data from local components database</p>';
            }
            return '<p>Syncing data from global database server,</p>';
        } else if (this.updateData.state === 'paused') {
            this.continueous_sync.counter_action = 'Resume Sync';
            this.showBar = true;
            if (this.currentUpdate == 'offline') {
                this.continueous_sync.counter_action = 'Resume Sync';
                return '<p>Offline Data sync has paused,</p>';
            }
            return '<p>Data sync from global database server has paused,</p>';
        } else if (this.updateData.state === 'normal' || this.updateData.state === 'onboarding_vulnerabilities') {
            this.showBar = false;
            this.continueous_sync.counter_action = 'Start Sync (Online)';
            if (this.updateType == 'offline') {
                this.continueous_sync.counter_action = 'Upload local update';
            }

            if (this.updateData.updates_mode == 'offline') {
                return `<p>Last synced  with local data server on ${new Date(this.updateData.updated)} (Offline)</p>`;
            }


            let date = this.$filter('date')(this.updateData.updated);
            return `<p>Last synced with global data server on  ${date} (Online)</p>`;
        } else if (this.updateData.state === 'failed') {
            this.continueous_sync.counter_action = 'Retry Sync';
            if (this.updateType == 'offline') {
                this.continueous_sync.counter_action = 'Retry upload local update';

            }
            if (this.currentPage === 'home') {
                return `Error: ` + this.updateData.errorMsg;
            }

            return `Error: ` + this.updateData.errorMsg;
        }
    }

    abortSync() {
        this.modal.confirm('Are you sure you want to abort current sync ?')
            .then(() => {
                this.DatabaseSyncDao.abortSync().$promise.then(() => {
                    this.$timeout(() => {
                        this.getUpdateData();
                        delete this.currentTotal;
                        delete this.currentIndex;
                    }, 1500);

                });
            });
    }

    updateState(action) {
        //console.log('action is', action)
        if (action == 'Resume Sync' || action == 'Start Sync (Online)' || action == 'Retry Sync' || action == 'Upload' +
            ' local update' || action == 'Retry upload local update') {
            this.continueous_sync.counter_action = 'Pause Sync';
            this.updateData.state = 'running';

        } else {

            this.continueous_sync.counter_action = 'Resume Sync';
            this.updateData.state = 'paused';
            this.DatabaseSyncDao.pauseOnline().$promise.then(() => {
                //this.currentUpdate = 'online';
            });

        }
        //console.log(action.toLowerCase().indexOf('online'))
        if (action.toLowerCase() !== 'pause sync') {
            if (this.updateType == 'online') {
                this.DatabaseSyncDao.updateOnline().$promise.then(() => {

                });
            } else {
                this.DatabaseSyncDao.updateOffline().$promise.then((data) => {
                    this.currentUpdate = 'offline';
                });
            }
        }


    }

    secondsToString(seconds) {
        let numdays = Math.floor(seconds / 86400);
        let numhours = Math.floor((seconds % 86400) / 3600);
        let numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
        let numseconds = ((seconds % 86400) % 3600) % 60;
        if (numhours > 0) {
            return numhours + ' Hours ' + numminutes + ' Minutes ';
        }
        return numminutes + ' Minutes ';
    }
}

export function jfUpdateStatus() {

    return {
        restrict: 'E',
        scope: {
            updateType: '=?',
            currentUpdate: '=?',
            currentPage: '@?',
            onDataRecieved: '&?'
        },
        template: require('./jf_update_status.html'),
        controller: jfUpdateStatusController,
        controllerAs: 'jfUpdateStatus',
        bindToController: true
    };
}



// WEBPACK FOOTER //
// ./modules/xray/directives/jf_update_status/jf_update_status.js